(() => {
  function init(root) {
    // Shared layout for current and future product review sections.
    root.querySelectorAll('.mp-amazon-reviews__intro').forEach(note => note.remove());
    const compose = root.querySelector('#MerriPipReviews');
    if (compose) {
      let footer = compose.closest('.mp-reviews-compose-footer');
      if (!footer) {
        footer = document.createElement('div');
        footer.className = 'mp-reviews-compose-footer';
        footer.append(compose);
      }
      const archive = root.querySelector('.mprs-archive') || root;
      if (archive.lastElementChild !== footer) archive.append(footer);
    }
    if (root.dataset.reviewsReady) return;
    const list = root.querySelector('#MPLatestReviewsList');
    if (!list) return;
    root.dataset.reviewsReady = 'true';
    const reviews = Array.from(list.children);
    const size = Number(root.dataset.pageSize) || 6;
    const pages = Math.ceil(reviews.length / size);
    const pagination = root.querySelector('.mp-reviews-pagination');
    const controls = pagination.querySelector('nav');
    const status = pagination.querySelector('[role="status"]');
    let current = 1;
    const previewSize = Number(root.dataset.previewSize) || 0;
    let expanded = !previewSize;
    const previewToggle = root.querySelector('.mp-tree-view-all');
    previewToggle?.addEventListener('click', () => {
      expanded = !expanded;
      show(1, false);
      if (!expanded) root.scrollIntoView({block:'start', behavior:'auto'});
    });
    root.addEventListener('mp:review-list-open', () => { expanded = true; show(1, false); });

    root.querySelectorAll('.mp-amazon-review').forEach(article => {
      const quote = article.querySelector('blockquote');
      if (article.dataset.reviewDisplay === 'full' || quote.textContent.trim().length <= 1000) return;
      quote.id = `${root.id}-${article.dataset.reviewId}-text`;
      quote.classList.add('mp-review-text-collapsed');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mp-review-read-more';
      button.textContent = 'Read full review';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', quote.id);
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        quote.classList.toggle('mp-review-text-collapsed', !expanded);
        button.textContent = expanded ? 'Show less' : 'Read full review';
      });
      quote.after(button);
    });

    const buttons = [];
    function addButton(label, target, ariaLabel) {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = label;
      button.setAttribute('aria-label', ariaLabel);
      button.setAttribute('aria-controls', list.id);
      button.addEventListener('click', () => show(typeof target === 'function' ? target() : target, true));
      controls.append(button);
      return button;
    }
    const previous = addButton('Previous', () => current - 1, 'Previous review page');
    for (let page = 1; page <= pages; page++) {
      buttons.push(addButton(String(page), page, `Review page ${page}`));
    }
    const next = addButton('Next', () => current + 1, 'Next review page');
    function show(page, navigate) {
      current = Math.max(1, Math.min(page, pages));
      const start = expanded ? (current - 1) * size : 0;
      const visibleSize = expanded ? size : previewSize;
      reviews.forEach((review, index) => { review.hidden = index < start || index >= start + visibleSize; });
      pagination.hidden = !expanded || pages <= 1;
      if (previewToggle) {
        previewToggle.setAttribute('aria-expanded', String(expanded));
        previewToggle.textContent = expanded ? 'Show less' : 'View all ↗';
      }
      previous.disabled = current === 1;
      next.disabled = current === pages;
      buttons.forEach((button, index) => {
        if (index + 1 === current) button.setAttribute('aria-current', 'page');
        else button.removeAttribute('aria-current');
      });
      status.textContent = `Showing ${start + 1}–${Math.min(start + size, reviews.length)} of ${reviews.length} ${previewSize ? 'reviews' : 'latest reviews'} · Page ${current} of ${pages}`;
      if (navigate) {
        const heading = root.querySelector('#MPLatestReviewsHeading');
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    }
    if (reviews.length) show(1, false);
    pagination.hidden = !expanded || pages <= 1;
  }
  function initAll() { document.querySelectorAll('.mp-amazon-reviews').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
